export default __webpack_public_path__ + "assets/cedic-cedilab-component.8b0f1bba.svg";